import { ArrowDown, ArrowUp } from "lucide-react";
import { cn } from "@/lib/utils";

type Props = {
  label: string;
  value: string;
  delta: {
    value: string;
    positive: boolean | null;
  } | null;
  active?: boolean;
  onClick?: () => void;
};

export function MetricCard({ label, value, delta, active, onClick }: Props) {
  const positive = delta?.positive === true;
  const negative = delta?.positive === false;
  const neutral = !delta || delta.positive === null;

  return (
    <div
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
      onClick={onClick}
      onKeyDown={onClick ? (e) => { if (e.key === "Enter" || e.key === " ") onClick(); } : undefined}
      className={cn(
        "relative rounded-xl border bg-card p-6 transition-colors",
        onClick && "cursor-pointer hover:bg-accent/40",
        active && "ring-2 ring-primary/50"
      )}
    >
      {delta && (
        <div
          title="Week over week change"
          className={cn(
            "absolute right-4 top-4 flex items-center gap-0.5 rounded-full px-2 py-0.5 text-xs font-medium",
            positive && "bg-emerald-100 text-emerald-700",
            negative && "bg-rose-100 text-rose-700",
            neutral && "bg-slate-100 text-slate-600"
          )}
        >
          {positive && <ArrowUp className="h-3 w-3" />}
          {negative && <ArrowDown className="h-3 w-3" />}
          {delta.value}
        </div>
      )}
      <div className="mt-2 text-4xl font-semibold tracking-tight">{value}</div>
      <div className="mt-3 text-sm font-medium text-muted-foreground">
        {label}
      </div>
    </div>
  );
}
